import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as XLSX from 'xlsx';
import DialogInput from 'screens/components/advanced/DialogInput';
import Button from 'screens/components/basic/Button';
import DialogTitleWithClose from 'screens/components/basic/DialogHeaderWithClose';
import GenericTable from 'screens/components/advanced/GenericTable';
import { getProductsFromExcelBulkTransfer } from 'actions/EntityActions';


class ExcelUploadBulkTransfer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            confirmDialog: false,
            excelUploadProducts: [],
            foundProducts: {
                list: [],
                noQuantityProducts: []
            }
        };
        this.mapUploadProducts = this.mapUploadProducts.bind(this);
    }

    componentWillReceiveProps(newProps) {
        if (newProps.foundProducts && this.props.foundProducts !== newProps.foundProducts) {
            this.setState({ foundProducts: newProps.foundProducts, confirmDialog: true });
        }
    }

    uploadFile = (e, callback) => {
        e.preventDefault();
        var reader = new FileReader();
        reader.readAsArrayBuffer(e.target.files[0]);
        reader.onload = function (e) {
            let data = new Uint8Array(reader.result);
            let wb = XLSX.read(data, { type: 'array' });
            let htmlstr = XLSX.write(wb, { sheet: wb.SheetNames[1], type: 'binary', bookType: 'csv' });

            let productArray = [];
            let existingSKU = new Set();
            let splitedCSV = htmlstr.split("\n");

            for (let i = 5; i < splitedCSV.length; i++) {
                let splitedData = splitedCSV[i].split(",");
                let SKU = splitedData[0];
                let ProductName = splitedData[1];
                let SelectedPackageReference = splitedData[2];

                if ((SKU === "" || SKU == undefined || SKU == null)) {
                    continue;
                }

                let model = {
                    SKU: SKU,
                    ProductName,
                    SelectedPackageReference
                };

                if (!existingSKU.has(SKU)) {
                    existingSKU.add(SKU);
                    productArray.push(model);
                }

            }


            callback(productArray);
        }
    }

    callback = (productArray) => {

        this.setState({ excelUploadProducts: productArray });

        let model = {
            WarehouseId: this.props.warehouseId,
            ProductList: productArray
        }
        this.props.getProductsFromExcelBulkTransfer(model);

    }

    closeDialog = () => {
        this.setState({ confirmDialog: false });
        this.setState({ foundProducts: { list: [], noQuantityProducts: [] } });
    }

    addProducts = () => {
        this.props.addProductsExcelToTransfer(this.state.foundProducts.list, this.state.excelUploadProducts);
        this.closeDialog();
    }

    mapUploadProducts = (productList, excelUploadProducts) => {
        return productList.map((item) => {

            let selectedPackageReference = excelUploadProducts.filter(x => x.SKU == item.productSKU).length > 0 ? excelUploadProducts.filter(x => x.SKU == item.productSKU)[0].SelectedPackageReference : "";

            let filterPackageReferences = item.warehouses.filter(x => x.packageReference == selectedPackageReference);
            let matchedPackageReference = filterPackageReferences.length > 0 ? filterPackageReferences[0].packageReference : "";

            return {
                ProductName: (<div>{item.productName}</div>),
                SKU: (<div>{item.productSKU}</div>),
                SelectedPackageReference: (<div>{matchedPackageReference}</div>)
            }
        })
    }

    render() {
        const styles = {
            uploadInput: {
                cursor: 'pointer',
                position: 'absolute',
                top: 0,
                bottom: 0,
                right: '2px',
                left: 0,
                width: '100%',
                opacity: 0
            }
        };
        const columnNames = [
            { key: "ProductName", label: "Product Name" },
            { key: "SKU", label: "SKU" },
            { key: "SelectedPackageReference", label: "Package Reference" }
        ];
        return (
            <React.Fragment>
            <Button
                label="Import Products From Excel"
                labelPosition="before"
                id="buttonImportFromExcel"
                containerElement="label"
                style={styles.uploadButton}
                primary={true}
                className="btn-space mb-2"
            >
                <input className="fileInput"
                    type="file"
                    style={styles.uploadInput}
                    id="inputImportFromPO"
                    onChange={(e) => this.uploadFile(e, this.callback)}
                    onClick={(e) => e.target.value = null}
                />
            </Button>
            <DialogInput
                title={<DialogTitleWithClose text="Upload from Excel" handleClose={() => this.closeDialog()}/>}
                actions={[
                    <Button
                        key={1}
                        type="CancelButton"
                        name="buttonCancel"
                        className="btn-space"
                        label="Cancel"
                        onTouchTap={() => this.closeDialog()} />,
                    <Button
                        key={2}
                        name="ConfirmButton"
                        label="Add"
                        primary={true}
                        onTouchTap={() => this.addProducts()} />
                ]}
                modal={true}
                handleClose={() => this.closeDialog()}
                autoScrollBodyContent={true}
                open={this.state.confirmDialog}>
                    <h4>Products to add:</h4>
                    <GenericTable
                        className="table_center table_centerText"
                        compName="uploadFromExcel"
                        stripedRows={true}
                        columns={columnNames}
                        rows={this.mapUploadProducts(this.state.foundProducts.list, this.state.excelUploadProducts)}
                        tableBodyClassName="inventoryAjudtTable" />
                    <br />
                    <p>Note: If a package reference you have entered is missing, make sure you have entered the package reference correctly or there is enough quantity of that package in the warehouse you are transferring from.</p>
                    {this.state.foundProducts.noQuantityProducts.length > 0 ?
                        <div>
                            <hr />
                            <p>The following products do not have any packages with enough quantity in the warehouse you are transfering from:</p>
                            <ul>
                                {this.state.foundProducts.noQuantityProducts.map((item) =>
                                    <li>
                                        Product Name: {item.productName}, SKU: {item.productSKU}
                                    </li>
                                )}
                            </ul>
                        </div> : ""
                    }
            </DialogInput>
            </React.Fragment>
        );
    }
}

function mapStatetoProps(state) {
    return {
        branchId: state.common.branchId,
        foundProducts: state.entity.bulkTransferExcelProducts
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getProductsFromExcelBulkTransfer: (model) => dispatch(getProductsFromExcelBulkTransfer(model))
    }
}

export default connect(mapStatetoProps, mapDispatchToProps)(ExcelUploadBulkTransfer);